<div *ngIf="loading" class="progress rounded-0" >
    <div class="rounded-0 progress-bar progress-bar-striped progress-bar-animated" role="progressbar"  style="min-width: 100%"></div>
</div>